/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { ToolTip, Icon } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './cardwrapper_styles';



/* ========== ~~~~~~~~~~ CARD WRAPPER ~~~~~~~~~~ ========== */
const CardWrapper = injectSheet(styles)((props) => {
    return (
        <div className={`cardwrapper ${props.classes.cardwrapper} ${props.klass} isActive-${props.isActive || false}`} onClick={props.handleClick}>
            {props.children}
            {!!props.tooltipContent &&
                <ToolTip position={`top`} action={`mouseenter`} content={<div className={`tip-inner ${props.classes.tooltipStyles}`}>{props.tooltipContent}</div>}>
                    <Icon name={`question-circle`} />
                </ToolTip>}
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CardWrapper;
